<template>
    <a-form-model ref="formModel" v-bind="$attrs">
        <slot></slot>
        <div style="text-align: center; padding-top: 10px;">
            <SaveButton :action="submit" :disabled="disabled" :title="buttonTitle" style="width: 120px;"/>
        </div>
    </a-form-model>
</template>

<script>
    import SaveButton from "./SaveButton";

    export default {
        name: "FormModel",
        components: {SaveButton},
        props: {
            action: {
                type: Function,
                required: true,
            },
            disabled: Boolean,
            buttonTitle: String,
        },
        methods: {
            submit() {
                return this.$refs.formModel.validate()
                    .then(() => {
                        return this.action().then((res) => {
                            this.$message.success("保存成功");
                            this.$emit("saved", res); // done
                        }).catch((err) => {
                            console.log(err); // debug
                            if (typeof err === "string") {
                                this.$message.error(`保存失败，${err}`);
                            } else {
                                this.$message.error(`保存失败`);
                            }
                        });
                    })
                    .catch((err) => {
                        console.log(err); // debug
                        this.$message.error("请根据提示核验并修改完善");
                    });
            }
        }
    }
</script>
